import { RefObject, useEffect } from "react";

export function useSelectedFocusManager<
    TContainer extends HTMLElement,
    TTarget extends HTMLElement,
>(
    selected: boolean,
    containerRef: RefObject<TContainer>,
    targetRef: RefObject<TTarget>,
) {
    useEffect(() => {
        if (
            !selected &&
            containerRef.current &&
            document.activeElement &&
            containerRef.current.contains(document.activeElement) &&
            document.activeElement instanceof HTMLElement
        ) {
            document.activeElement.blur();
        }

        if (selected && targetRef.current) {
            targetRef.current.scrollIntoView({
                behavior: "auto",
                inline: "start",
                block: "nearest",
            });
            if (!(document.activeElement instanceof HTMLInputElement)) {
                targetRef.current.focus();
            }
        }
    }, [selected, containerRef, targetRef]);
}
